<div>
  @switch (question.singleChoicetype) {
    @case ('Dropdown') {
      <select class="form-control" [class.is-invalid]="isIncorrectSelection" [id]="question.key" [(ngModel)]="selectedValue" [ngModelOptions]="{standalone: true}" (ngModelChange)="onSelectionChange($event)">
        <option value="">Select</option>
        @for (option of question.options; track option) {
          <option [value]="option.value">{{option.value}}</option>
        }
      </select>
    }
    <!--<ng-container *ngSwitchCase="'Radio Button'">
    <div class="radio-container">
      <label class="radio-wrapper mr-3" *ngFor="let option of question.options">{{option.value}}
        <input type="radio" name="assessment" [value]="option.value" [id]="option.value">
        <span class="check-mark-radio"></span>
      </label>
    </div>
  </ng-container> -->
  @case ('Radio Button') {
    @for (option of question.options; track option) {
      <div class="radio-container">
        <label [ngClass]="question.disabled ? 'radio-wrapper _radio-disabled':'radio-wrapper'">{{ question.getterValue ? getValue(option, question.getterValue) : option.value || option.value }}
          <input type="radio" [checked]="isSelected(option, question)"
            [value]="question.getterKey ? getKey(option,question) : option.id || option.value"
            [id]="question.getterKey ? getKey(option,question) : option.id || option.value">
          <span class="check-mark-radio"></span>
        </label>
      </div>
    }
  }
}
</div>
